import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'db-questionnaire-dialog',
  templateUrl: './questionnaire-dialog.component.html',
  styleUrls: ['./questionnaire-dialog.component.scss']
})
export class QuestionnaireDialogComponent implements OnInit {
  questionnaireForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public questionnaireDialogRef: MatDialogRef<QuestionnaireDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.questionnaireForm = this.formBuilder.group({
      questionnaireId: this.data.questionnaireId ? this.data.questionnaireId : '',
      questionnaireName: [this.data.questionnaireName ? this.data.questionnaireName : '', Validators.required],
    });
  }

  addQuestionnaire() {
    const questionnaireFormValue = JSON.stringify(this.questionnaireForm.value);

    this.questionnaireDialogRef.close(questionnaireFormValue);
  }
}
